import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import i18n from "@/assets/lang/index";
import store from "@/store";
const t = i18n.global.t;

let routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/HomeView.vue"),
    meta: {
      title: t("home.title"),
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginView.vue"),
    meta: {
      title: t("login.title"),
      public: true,
    },
  },
  {
    path: "/wxLogin",
    name: "wxLogin",
    component: () => import("@/views/WxLoginView.vue"),
    meta: {
      title: t("login.title"),
      public: true,
    },
  },
  {
    path: "/reset",
    name: "reset",
    component: () => import("@/views/ResetView.vue"),
    meta: {
      title: t("reset.title"),
      public: true,
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/RegisterView.vue"),
    meta: {
      title: t("register.title"),
      public: true,
    },
  },
  {
    path: "/license",
    name: "license",
    component: () => import("@/views/LicenseView.vue"),
    meta: {
      title: t("license.title"),
      public: true,
    },
  },
];
const systemRoutes: Array<RouteRecordRaw> = [
  {
    path: "/user",
    name: "user:page",
    component: () => import("@/views/system/UserView.vue"),
    meta: {
      title: t("system.user.title"),
    },
  },
  {
    path: "/org",
    name: "org:page",
    component: () => import("@/views/system/OrgView.vue"),
    meta: {
      title: t("system.org.title"),
    },
  },
  {
    path: "/perm",
    name: "perm:page",
    component: () => import("@/views/system/PermView.vue"),
    meta: {
      title: t("system.perm.title"),
    },
  },
  {
    path: "/role",
    name: "role:page",
    component: () => import("@/views/system/RoleView.vue"),
    meta: {
      title: t("system.role.title"),
    },
  },
  {
    path: "/dict",
    name: "dict:page",
    component: () => import("@/views/system/DictView.vue"),
    meta: {
      title: t("system.dict.title"),
    },
  },
  {
    path: "/msg",
    name: "msg:page",
    component: () => import("@/views/system/MsgView.vue"),
    meta: {
      title: t("system.msg.title0"),
    },
  },
  {
    path: "/file",
    name: "file:page",
    component: () => import("@/views/system/FileView.vue"),
    meta: {
      title: t("system.file.title"),
    },
  },
  {
    path: "/config",
    name: "config:page",
    component: () => import("@/views/system/ConfigView.vue"),
    meta: {
      title: t("system.config.title"),
    },
  },
];

const rezRoutes: Array<RouteRecordRaw> = [
  {
    path: "/shop",
    name: "shop:page",
    component: () => import("@/views/rez/ShopView.vue"),
    meta: {
      title: t("rez.shop.title"),
    },
  },
  {
    path: "/rez",
    name: "rez:page",
    component: () => import("@/views/rez/RezView.vue"),
    meta: {
      title: t("rez.rez.title"),
    },
  },
  {
    path: "/reward",
    name: "reward:page",
    component: () => import("@/views/rez/RewardView.vue"),
    meta: {
      title: t("rez.reward.title"),
    },
  },
  {
    path: "/shop/:id/room",
    name: "room:page",
    component: () => import("@/views/rez/RoomView.vue"),
    meta: {
      title: t("rez.room.title"),
    },
  },
  {
    path: "/salaryArc",
    name: "salaryArc:page",
    component: () => import("@/views/rez/SalaryArcView.vue"),
    meta: {
      title: "薪资存档",
    },
  },
  {
    path: "/room/:id/device",
    name: "device:page",
    component: () => import("@/views/rez/DeviceView.vue"),
    meta: {
      title: t("rez.device.title"),
    },
  },
  {
    path: "/member",
    name: "member:page",
    component: () => import("@/views/rez/MemberView.vue"),
    meta: {
      title: t("rez.member.title"),
    },
  },
  {
    path: "/rechargeCard",
    name: "rechargeCard:page",
    component: () => import("@/views/rez/RechargeCardView.vue"),
    meta: {
      title: t("rez.rechargeCard.title"),
    },
  },
  {
    path: "/employee",
    name: "employee:page",
    component: () => import("@/views/rez/EmployeeView.vue"),
    meta: {
      title: "员工管理",
    },
  },
  {
    path: "/dashboard",
    name: "rez:dashboard",
    // component: () => import("@/views/rez/DashboardView.vue"),
    component: () => {
      const projectType = store.getters.projectType;
      // const project = store.state.project;
      if (projectType === "mate") {
        return import("@/views/rez/MateDashboardView.vue");
      } else {
        return import("@/views/rez/DashboardView.vue");
      }
    },
    meta: {
      title: t("rez.dashboard.title"),
    },
  },
  {
    path: "/salary/dashboard",
    name: "salary:dashboard",
    // component: () => import("@/views/rez/DashboardView.vue"),
    component: () => {
      return import("@/views/salary/DashboardView.vue");
    },
    meta: {
      title: t("rez.dashboard.title"),
    },
  },
];

const mRezRoutes: Array<RouteRecordRaw> = [
  {
    path: "/m",
    name: "m:home",
    component: () => import("@/views/m/HomeView.vue"),
    meta: {
      title: t("home.title"),
    },
  },
  {
    path: "/m/rez",
    name: "m:rez:page",
    component: () => import("@/views/m/rez/RezView.vue"),
    meta: {
      title: t("rez.rez.title"),
    },
  },
  {
    path: "/m/room",
    name: "m:room:page",
    component: () => import("@/views/m/rez/RoomView.vue"),
    meta: {
      title: t("rez.room.title"),
    },
  },
  {
    path: "/m/dashboard",
    name: "m:rez:dashboard",
    // component: () => import("@/views/rez/DashboardView.vue"),
    component: () => {
      const projectType = store.getters.projectType;
      // const project = store.state.project;
      if (projectType === "mate") {
        return import("@/views/rez/MateDashboardView.vue");
      } else {
        return import("@/views/m/rez/DashboardView.vue");
      }
    },
    meta: {
      title: t("rez.dashboard.title"),
    },
  },
  {
    path: "/m/product",
    name: "m:product:showcase",
    component: () => import("@/views/m/cat/ProductShowcaseView.vue"),
    meta: {
      title: "商品展示",
      public: true,
      bare: true,
    },
  },
  {
    path: "/m/product/:id",
    name: "m:product:detail",
    component: () => import("@/views/m/cat/ProductDetailShowcaseView.vue"),
    meta: {
      title: "商品详情",
      public: true,
      bare: true,
    },
  },
];

const mateRoutes: Array<RouteRecordRaw> = [
  {
    path: "/mate",
    component: () => import("@/views/mate/MateLayout.vue"),
    meta: { bare: true },
    children: [
      { path: "", redirect: "/mate/home" },
      {
        path: "home",
        name: "mate:home",
        component: () => import("@/views/mate/HomeView.vue"),
        meta: { title: "首页", public: true, bare: true },
      },
      {
        path: "shop",
        name: "mate:shop",
        component: () => import("@/views/mate/ShopView.vue"),
        meta: { title: "店铺", public: true, bare: true },
      },
      {
        path: "product",
        name: "mate:product",
        component: () => import("@/views/mate/ProductView.vue"),
        meta: { title: "商品浏览", public: true, bare: true },
      },
      {
        path: "product/:id",
        name: "mate:product:detail",
        component: () => import("@/views/mate/ProductDetailView.vue"),
        meta: { title: "商品详情", public: true, bare: true },
      },
      {
        path: "login",
        name: "mate:login",
        component: () => import("@/views/mate/LoginView.vue"),
        meta: { title: "登录", public: true, bare: true },
      },
      {
        path: "bind-phone",
        name: "mate:bind-phone",
        component: () => import("@/views/mate/BindPhoneView.vue"),
        meta: { title: "绑定手机号", bare: true },
      },
      {
        path: "me",
        name: "mate:me",
        component: () => import("@/views/mate/MeView.vue"),
        meta: { title: "我的", bare: true },
      },
      {
        path: "product-set",
        name: "mate:product-set",
        component: () => import("@/views/mate/ProductSetListView.vue"),
        meta: { title: "我已玩过", bare: true },
      },
      {
        path: "product-set-phone",
        name: "mate:product-set-phone",
        component: () => import("@/views/mate/ProductSetPhoneView.vue"),
        meta: { title: "玩过查询", bare: true },
      },
      {
        path: "room/:id",
        name: "mate:room",
        component: () => import("@/views/mate/RoomDetailView.vue"),
        meta: { title: "护航详情", bare: true },
      },
      {
        path: "room/:id/v2",
        name: "mate:room:v2",
        component: () => import("@/views/mate/V2RoomDetailView.vue"),
        meta: { title: "护航看板", bare: true },
      },
      {
        path: "reward",
        name: "mate:reward",
        component: () => import("@/views/mate/RewardListView.vue"),
        meta: { title: "订单", bare: true },
      },
      {
        path: "reward/pay",
        name: "mate:reward:pay",
        component: () => import("@/views/mate/RewardPayView.vue"),
        meta: { title: "下单支付", bare: true },
      },
      {
        path: "reward/:id",
        name: "mate:reward:detail",
        component: () => import("@/views/mate/RewardDetailView.vue"),
        meta: { title: "订单详情", bare: true },
      },
      {
        path: "reward/:id/edit",
        name: "mate:reward:edit",
        component: () => import("@/views/mate/RewardEditView.vue"),
        meta: { title: "编辑订单", bare: true },
      },
      {
        path: "coupon",
        name: "mate:coupon",
        component: () => import("@/views/mate/CouponView.vue"),
        meta: { title: "优惠券", bare: true },
      },
      {
        path: "gacha",
        name: "mate:gacha",
        component: () => import("@/views/mate/GachaView.vue"),
        meta: { title: "抽卡", bare: true },
      },
    ],
  },
];

const catRoutes: Array<RouteRecordRaw> = [
  {
    path: "/category",
    name: "category:page",
    component: () => import("@/views/cat/CategoryView.vue"),
    meta: {
      title: "商品类别",
    },
  },
  {
    path: "/product",
    name: "product:page",
    component: () => import("@/views/cat/ProductView.vue"),
    meta: {
      title: "商品管理",
    },
  },
  {
    path: "/productSet",
    name: "productSet:page",
    component: () => import("@/views/cat/ProductSetView.vue"),
    meta: {
      title: "商品组合",
    },
  },
  {
    path: "/productSetPhone",
    name: "productSetPhone:page",
    component: () => import("@/views/cat/ProductSetPhoneView.vue"),
    meta: {
      title: "手机号兑换商品组合",
    },
  },
];

const ponitRoutes: Array<RouteRecordRaw> = [
  {
    path: "/coupon",
    name: "coupon:page",
    component: () => import("@/views/point/CouponView.vue"),
    meta: {
      title: "优惠券管理",
    },
  },
  {
    path: "/couponCode",
    name: "couponCode:page",
    component: () => import("@/views/point/CouponCodeView.vue"),
    meta: {
      title: "优惠券口令",
    },
  },
  {
    path: "/userCoupon",
    name: "userCoupon:page",
    component: () => import("@/views/point/UserCouponView.vue"),
    meta: {
      title: "用户优惠券管理",
    },
  },
  {
    path: "/pointRecord",
    name: "pointRecord:page",
    component: () => import("@/views/point/PointRecordView.vue"),
    meta: {
      title: "积分流水",
    },
  },
];

const gachaRoutes: Array<RouteRecordRaw> = [
  {
    path: "/gachaPool",
    name: "gachaPool:page",
    component: () => import("@/views/gacha/GachaPoolView.vue"),
    meta: {
      title: "奖池管理",
    },
  },
  {
    path: "/gachaPrize",
    name: "gachaPrize:page",
    component: () => import("@/views/gacha/GachaPrizeView.vue"),
    meta: {
      title: "奖品管理",
    },
  },
  {
    path: "/gachaPoolPrize",
    name: "gachaPoolPrize:page",
    component: () => import("@/views/gacha/GachaPoolPrizeView.vue"),
    meta: {
      title: "奖池奖品配置",
    },
  },
  {
    path: "/gachaPlay",
    name: "gacha:play",
    component: () => import("@/views/gacha/GachaPlayView.vue"),
    meta: {
      title: "抽奖",
    },
  },
  {
    path: "/gachaDraw",
    name: "gachaDraw:page",
    component: () => import("@/views/gacha/GachaDrawView.vue"),
    meta: {
      title: "抽奖记录",
    },
  },
  {
    path: "/gachaUserPrize",
    name: "gachaUserPrize:page",
    component: () => import("@/views/gacha/GachaUserPrizeView.vue"),
    meta: {
      title: "奖品记录",
    },
  },
];

const tempRoutes: Array<RouteRecordRaw> = [
  {
    path: "/temp",
    name: "temp:page",
    component: () => import("@/views/temp/TempView.vue"),
    meta: {
      title: t("temp"),
    },
  },
];
routes = routes.concat(
  systemRoutes,
  rezRoutes,
  mRezRoutes,
  mateRoutes,
  catRoutes,
  ponitRoutes,
  gachaRoutes,
  tempRoutes
);
const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(process.env.BASE_URL),
  // history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title}`;
  }
  const isMate = to.path === "/mate" || to.path.startsWith("/mate/");
  if (isMate && !to.meta.public) {
    const userId = store.state.auth?.user?.id;
    if (!userId) {
      next({
        path: "/mate/login",
        query: { redirect: to.fullPath },
      });
      return;
    }
  }
  next();
});
export default router;
